import React from "react";
import { useTranslation } from "react-i18next";

/**
 * "In plain English" block used inside /privacy and /terms sections.
 * The pseudo-label "In plain English" is rendered as a localized span
 * (not a ::before) so it translates cleanly across EN / ES.
 */
export default function PlainEnglish({ children, testId = "plain-english" }) {
    const { t } = useTranslation();
    return (
        <div className="plain-english" data-testid={testId}>
            <span className="plain-english-label mono">
                {t("legal.plainEnglishLabel")}
            </span>
            <div className="plain-english-body">{children}</div>
        </div>
    );
}
